/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactNode } from 'react';
import { Box } from '@components/design-system';
import { getURLFromIPFSURI, Node } from '@utils/ipfs';
import * as Styles from './styles';

interface IThumbnailBoard {
  cover?: string;
  images?: string[];
  icon?: ReactNode | null;
}

export const ThumbnailBoard: FC<IThumbnailBoard> = ({ cover, images, icon }) => {
  return (
    <Box css={{ flexDirection: 'column' }}>
      <Styles.Square css={{ backgroundImage: cover && `url(${getURLFromIPFSURI(cover, Node.INFURA)})` }}>
        {!cover && images && (
          <Styles.TokenHolder>
            {images.map((image) => {
              return <Box key={image} css={{ backgroundImage: `url(${image})`, imageRendering: 'pixelated' }} />;
            })}
          </Styles.TokenHolder>
        )}

        {icon && <Box css={{ i: { fontSize: 64 } }}>{icon}</Box>}
      </Styles.Square>
    </Box>
  );
};
